import { observer } from 'mobx-react';
import { IValidationGroup } from '../../../../../../../hooks/validation-group/validation-group-hook';
import { FormFieldLine } from '../../../../../../../components/form-field-line/form-field-line';
import { Input } from '../../../../../../../components/inputs/input/input';
import GlobalECredentialsStore from '../../../../stores/credentials/shipping/global-e-credentials-store';

interface IProps {
    credentialsStore: GlobalECredentialsStore,
    vGroup: IValidationGroup,
}

const GlobalECredentials: React.FC<IProps> = observer(({
                                                         credentialsStore,
                                                         vGroup,
                                                     }) => {
    return (
        <>
            <FormFieldLine
                required
                label='Global-E Base Api Url'
                key='baseApiUrl'
                note='Example: https://connect-qa.bglobale.com'
            >
                <Input
                    value={credentialsStore.baseApiUrl}
                    onChange={credentialsStore.setBaseApiUrl}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine
                required
                label='Global-E Merchant GUID'
                key='apiUsername'
                note='Your Global-E Merchant GUID'
            >
                <Input
                    value={credentialsStore.apiUsername}
                    onChange={credentialsStore.setApiUsername}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
        </>
    );
});

export default GlobalECredentials;
